export default __webpack_public_path__ + "static/media/brandenburger-tor-ge74e897d2_1920.e19ec04e.jpg";